import * as Yup from 'yup';

const Validation = Yup.object({
  email: Yup.string().required("Email Required").email("Invalid email address"),
});

export default Validation;
